/**
 * @flow
 * @author: VaraKumar
 */

import styled from 'react-emotion'

import colors from '../../../themes/Colors'

import ResponsiveContainer from '../../core/ResponsiveContainer'
import { mobile, tablet, desktop, mdDesktop } from '../../../utils/mixins'

// TODO: Have to remove font-size in px and have add em based on body section
export const TestimonialSectionContainer = styled(ResponsiveContainer)`
  ${mobile} {
    font-size: 14px;
  }
  ${tablet} {
    font-size: 16px;
  }
  ${desktop} {
    font-size: 16px;
  }
`
export const TestimonialSectionWrapper = styled('div')`
  background: ${colors.darkTwoDefault};
  ${desktop} {
    padding-bottom: 4.063em;
    padding-top: 30px;
  }
  ${tablet} {
    padding-bottom: 4.643em;
  }
  ${mobile} {
    padding-bottom: 55px;
    padding-top: 25px;
  }
`

export const MobileComponent = styled('div')`
  ${desktop} {
    display: none;
  }
  ${tablet} {
    display: none;
  }
  ${mdDesktop} {
    display: none;
  }
`

export const DesktopComponent = styled('div')`
  ${tablet} {
    display: none;
  }
  ${mobile} {
    display: none;
  }
  ${mdDesktop} {
    display: none;
  }
`
export const TabletComponent = styled('div')`
  ${desktop} {
    display: none;
  }
  ${mobile} {
    display: none;
  }
`
export const MdDesktopComponent = styled('div')`
  display: none;
  ${mdDesktop} {
    display: block;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/TestimonialSection/styledComponents.js